'use client';

import { AppRouterCacheProvider } from '@enlighten/design-system/dist/nextjs-v14-appRouter';
import ThemeProvider from '@enlighten/design-system/dist/ThemeProvider';

import { fonts } from '@/styles/fonts';
import { theme } from '@/styles/theme';

import type { ErrorProps } from './error';
import Error from './error';

export default function GlobalError({ error, reset }: ErrorProps) {
	return (
		<html lang="ko">
			<body className={fonts.className}>
				<AppRouterCacheProvider>
					<ThemeProvider theme={theme}>
						<Error error={error} reset={reset} />
					</ThemeProvider>
				</AppRouterCacheProvider>
			</body>
		</html>
	);
}
